// test1662
(1662 && 0);
